export interface FXTheme {
  id: string;
  name: string;
  hitColor: number;
  trailColor: number;
  ringColor: number;
  particleCount: number;
  isPaid: boolean;
}

export const FX_THEMES: FXTheme[] = [
  {
    id: "default",
    name: "Standard",
    hitColor: 0x00ff88,
    trailColor: 0x44aaff,
    ringColor: 0xffffff,
    particleCount: 8,
    isPaid: false,
  },
  {
    id: "neon",
    name: "Neon Burst",
    hitColor: 0xff00ff,
    trailColor: 0x00ffff,
    ringColor: 0xffff00,
    particleCount: 16,
    isPaid: true,
  },
  {
    id: "fire",
    name: "Inferno",
    hitColor: 0xff4400,
    trailColor: 0xff8800,
    ringColor: 0xff2200,
    particleCount: 16,
    isPaid: true,
  },
  {
    id: "boost",
    name: "Boost Special",
    hitColor: 0xffdd00,
    trailColor: 0xffaa00,
    ringColor: 0xffee66,
    particleCount: 24,
    isPaid: false, // granted via ticket
  },
];

export function getTheme(id: string): FXTheme {
  return FX_THEMES.find((t) => t.id === id) ?? FX_THEMES[0];
}
